import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @ViewChild("burger", {read: ElementRef}) burger: ElementRef;


  menuHidden = true;

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }

  toggleMenu() {
    this.menuHidden = !this.menuHidden;
  }

  goToValues ( ) {
    this.router.events.subscribe(s => {
      if (s instanceof NavigationEnd) {
        const tree = this.router.parseUrl(this.router.url);
        if (tree.fragment) {
          const x = document.querySelector('values');
          if (x) {
            x.scrollIntoView();
          }
        }
      }
    });
  }

  goToContact ( ) {
    this.router.events.subscribe(s => {
      if (s instanceof NavigationEnd) {
        const tree = this.router.parseUrl(this.router.url);
        if (tree.fragment) {
          const x = document.querySelector('#contact');
          if (x) {
            x.scrollIntoView();
          }
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/partials/header/header.component.ts